// src/utils/getStatusConfig.ts
import i18n from "@/i18n";
import { APOfferVacancyStatus } from "../../../model/VacancyApplicant.interface";

export interface StatusConfigItem {
  tone?: "error" | "warning" | "info" | "success";
  label: string;
  description?: string;
}

export function getVacancyStatusConfig(
  status: APOfferVacancyStatus
): StatusConfigItem {
  switch (status) {
    case "contract_building":
      return {
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.contract_building",
          "Mietvertrag wird erstellt"
        ),
      };
    case "contract_created":
      return {
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.ContractCreated",
          "Mietvertrag erstellt"
        ),
        description: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.ContractSentWaiting",
          "Die Erstellung des Mietvertrags wurde angestoßen."
        ),
      };

    case "contract_created_manual":
      return {
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.ContractCreatedManual",
          "Mietvertrag erstellt (manuell)"
        ),
      };

    case "contract_sent":
      return {
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.ContractSent",
          "Mietvertrag versendet"
        ),
      };

    case "signed":
      return {
        tone: "success",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.ContractSigned",
          "Mietvertrag unterschrieben"
        ),
      };

    case "signed_partially":
      return {
        tone: "warning",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.ContractSignedPartial",
          "Mietvertrag teilweise unterschrieben"
        ),
      };

    case "signed_landlord":
      return {
        tone: "info",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.ContractSignedLandlord.Title",
          "Mietvertrag vom Vermieter unterschrieben"
        ),
        description: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.ContractSignedLandlord.Text",
          "Der Mietvertrag wurde von allen Parteien unterschrieben. Das Dokument wird nun erstellt."
        ),
      };

    case "revoked":
      return {
        tone: "warning",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.Revoked.Title",
          "Mietvertrag zurückgezogen"
        ),
        description: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.Revoked.Text",
          "Der Mietvertrag wurde zurückgezogen."
        ),
      };

    case "send_failed":
      return {
        tone: "error",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.SendFailed.Title",
          "Fehler beim Versenden"
        ),
        description: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.SendFailed.Text",
          "Beim Versenden des Mietvertrags ist ein Fehler aufgetreten."
        ),
      };

    case "completed":
      return {
        tone: "success",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.Completed",
          "Mietvertrag abgeschlossen"
        ),
      };

    case "accepted":
      return {
        tone: "info",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.Accepted.Title",
          "Mieterinteressent freigegeben"
        ),
        description: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.Accepted.Text",
          "Der Mietinteressent wurde freigegeben."
        ),
      };

    case "declined":
      return {
        tone: "error",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.Declined.Title",
          "Mietvertrag abgelehnt"
        ),
        description: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.Declined.Text",
          "Der Mietvertrag wurde abgelehnt."
        ),
      };

    case "new":
      return {
        tone: "info",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.New",
          "Mietvertrag neu"
        ),
      };

    case "archived":
      return {
        tone: "info",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.Archived.Title",
          "Mietvertrag archiviert"
        ),
        description: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.Archived.Text",
          "Der Mietvertrag wurde archiviert."
        ),
      };
    case "rental_agreement_created":
      return {
        tone: "success",
        label: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.RentalAgreementCreated.Title",
          "Mietvertrag im System angelegt"
        ),
        description: i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.RentalAgreementCreated.Text",
          "Der Mietvertrag wurde erstellt und im System angelegt. Und kann nun in der Asset App eingesehen werden."
        ),
      };
    default:
      // any future or unknown status just returns the raw status as label
      return {
        tone: "info",
        label: status,
      };
  }
}
